import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import { Accion } from "./contexto/ClasesGrales";
import { colores, HOY, toInput, toOutput, SInput, SEtiqueta, SInputD, Scrudo } from "./general";
import Boton from "./Boton.js";

export default function CRUDaccion({ accion, set }) {
  // set permite actualizar variable para visualizar pantalla
  let { firebase } = useContext(AppContext);
  let color = colores["prioridad"];

  const [a, setA] = useState(accion ? accion : new Accion(firebase.proyectoActivo.proyecto.id, "...nueva..."));
  const [change, setChange] = useState(false)

  useEffect(() => {
    document.getElementById("Afechai").value = toInput(a.inicio);
    document.getElementById("Afechaf").value = a.finEstimado ? toInput(a.finEstimado) : null;
  }, [a.inicio, a.finEstimado]);

  async function actualizarAccion() {
    await firebase.actualizarAccion(a);
    if (set) set(false);
    setChange(false)
  }

  return (
    <div style={Scrudo}>
      <div style={Sdescripcion}>
        <div style={{ ...SEtiqueta, marginBottom: "5px" }}>{a.id} - Descripción:</div>
        <textarea
          rows="4"
          style={SInputD}
          value={a.descripcion}
          onChange={(e) => {
            e.persist(); setChange(true);
            setA((a) => ({ ...a, descripcion: e.target.value }));
          }}
        ></textarea>
      </div>

      <div style={SDataEntry}>
        <div style={SEtiqueta}>Prioridad:</div>
        <select
          value={a.prioridad}
          onChange={(e) => {
            e.persist(); setChange(true);
            setA((a) => ({ ...a, prioridad: e.target.value }));
          }}
          style={{ ...SInput, background: `${color[a.prioridad]}` }}
        >
          <option value="Alta" style={{ background: `${color["Alta"]}` }}>
            Alta
          </option>
          <option value="Media" style={{ background: `${color["Media"]}` }}>
            Media
          </option>
          <option value="Baja" style={{ background: `${color["Baja"]}` }}>
            Baja
          </option>
        </select>

        <div style={SEtiqueta}>Dimension:</div>
        <select
          style={SInput}
          value={a.dimension}
          onChange={(e) => {
            e.persist(); setChange(true);
            setA((a) => ({ ...a, dimension: e.target.value, fechaCierre: e.target.value === "cerrado" ? HOY : 0 }));
          }}
        >
          <option value="alcance">Alcance</option>
          <option value="cronograma">Cronograma</option>
          <option value="recursos">Recursos</option>
        </select>

        <div style={SEtiqueta}>Fecha Inicio:</div>
        <input
          id="Afechai"
          type="date"
          style={SInput}
          onChange={(e) => {
            e.persist(); setChange(true);
            setA((a) => ({ ...a, inicio: toOutput(e.target.value) }));
          }}
        ></input>
        <div style={SEtiqueta}>Fin Estimado:</div>
        <input
          id="Afechaf"
          type="date"
          style={SInput}
          onChange={(e) => {
            e.persist(); setChange(true);
            setA((a) => ({ ...a, finEstimado: toOutput(e.target.value) }));
          }}
        ></input>

        <div style={SEtiqueta}>Estado:</div>
        <select
          style={SInput}
          value={a.estado}
          onChange={(e) => {
            e.persist(); setChange(true);
            setA((a) => ({ ...a, estado: e.target.value, fechaCierre: e.target.value === "cerrado" ? HOY : 0 }));
          }}
        >
          <option value="pendiente">Pendiente</option>
          <option value="ejecutando">Ejecutando</option>
          <option value="suspendida">Suspendida</option>
          <option value="cerrada">Cerrada</option>
        </select>

        <div style={SEtiqueta}>Responsable:</div>
        <select
          value={a.responsable}
          onChange={(e) => {
            e.persist(); setChange(true);
            setA((a) => ({ ...a, responsable: e.target.value }));
          }}
          style={SInput}
        >
          {firebase.dataUsuarios.map((u, i) => (
            <option key={i} value={u.id}>
              {u.nombre}
            </option>
          ))}
        </select>
      </div>
      <Boton accion={actualizarAccion} change={change} />
    </div>
  );
}


const Sdescripcion = {
  marginBottom: "5px"
};

const SDataEntry = {
  display: "grid",
  gridTemplateColumns: "55% 40%",
  rowGap: "5px",
  columnGap: "5px"
};

